import { render, staticRenderFns } from "./fix-pdf.vue?vue&type=template&id=237bc87c&scoped=true&"
import script from "./fix-pdf.vue?vue&type=script&lang=js&"
export * from "./fix-pdf.vue?vue&type=script&lang=js&"
import style0 from "./fix-pdf.vue?vue&type=style&index=0&id=237bc87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237bc87c",
  null
  
)

export default component.exports